import { render, staticRenderFns } from "./HistoryTimeDetail.vue?vue&type=template&id=31b58025&scoped=true"
import script from "./HistoryTimeDetail.vue?vue&type=script&lang=js"
export * from "./HistoryTimeDetail.vue?vue&type=script&lang=js"
import style0 from "./HistoryTimeDetail.vue?vue&type=style&index=0&id=31b58025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b58025",
  null
  
)

export default component.exports